export type ChamberFaultStatus =
  | 'None'
  | 'NoLogger'
  | 'NoValidChannel'
  | 'NoValidAlarmConfiguration';

export const ChamberFaultStatus = {
  None: 'None' as ChamberFaultStatus,
  NoLogger: 'NoLogger' as ChamberFaultStatus,
  NoValidChannel: 'NoValidChannel' as ChamberFaultStatus,
  NoValidAlarmConfiguration: 'NoValidAlarmConfiguration' as ChamberFaultStatus,
};
